// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"18":"5b06307fdda68550","48":"b32a771fc71abe53","60":"40f8797f4fa65dc4","248":"78f260989062ae1e","251":"6d99b3c0431894c9","252":"3cb11521718a9a7b","361":"e9843683bcaa7b23","789":"0a5145f20d270647","825":"d15fc9e43131f587","936":"b7b5f54e3bc3601c","995":"8c32b935e086a8bf"}[chunkId] + ".js";
};